import { type AxiosInstance, type GenericAbortSignal } from 'axios';

export class DownloadFilesApi {
  constructor(private readonly api: AxiosInstance) {}

  public async imageToWebp(
    link: string,
    abortSignal?: GenericAbortSignal
  ): Promise<string> {
    const res = await this.api.post(
      `files/downloadmanually`,
      {
        link
      },
      {
        signal: abortSignal
      }
    );
    return res.data;
  }

  public async downloadBankFile(
    uuid: string,
    abortSignal?: GenericAbortSignal
  ): Promise<{ name: string; base64: string }> {
    const res = await this.api.get(`files/${uuid}/downloadmanually`, {
      signal: abortSignal
    });
    return res.data;
  }

  public async downloadTemplate(data: {
    template: string;
    type: string;
    values: string;
  }) {
    const res = await this.api.post('utils/xlsx_template_generate', data);
    return res.data;
  }

  public async downloadTemplatePdf(data: {
    template: string;
    values: string;
    iin?: string;
    request_id?: string;
    top_margin?: number;
    right_margin?: number;
    bottom_margin?: number;
    left_margin?: number;
  }) {
    const res = await this.api.post('utils/pdf_generate', {
      ...data,
      pdf_convert: true
    });
    return res.data;
  }

  public async downloadAdditionalFiles(data: any[]) {
    const res = await this.api.post(
      'responses/files/downloadAdditionalFiles',
      data
    );
    return res.data;
  }

  public async downloadEubankFilesManually(responseId: string) {
    const res = await this.api.get(
      `responses/files/${responseId}/downloadAdditionalFilesEubankMalually`
    );
    return res.data;
  }
}
